import { BrowserRouter } from "react-router-dom";
import AppContainer from "./layout/AppContainer";

function App() {
  return (
    <BrowserRouter>
      <div id="App" style={{ overflow: "Hidden", backgroundColor: "#f5f5f5" }}>
        <AppContainer />
      </div>
    </BrowserRouter>
  );
}

export default App;
